import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA , MatDialogRef} from '@angular/material/dialog';
import { PermissionsService } from 'app/service/permission/permissions.service';
import { PermissoesService } from 'app/service/usuario/permissoes.service';

@Component({
  selector: 'app-incluir-permissao-user',
  templateUrl: './incluir-permissao-user.component.html',
  styleUrls: ['./incluir-permissao-user.component.scss']
})
export class IncluirPermissaoUserComponent implements OnInit {
  public usuarioId;
  permissionNotInUser: any[];
  permissoesUser: any[];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private permissionService: PermissoesService) {
    console.log(data);
    this.usuarioId = data.usuario.id;
    this.permissionNotInUser = [];
    this.permissoesUser = [];
    permissionService.getPermissionNotInUser(data.usuario.id).subscribe(res => {
      this.permissoesUser = res;
    });
    permissionService.getPermissionInUser(data.usuario.id).subscribe(res => {
      this.permissionNotInUser = res;
    });
  }

  ngOnInit() {
    this.getPermissionInUser(this.usuarioId);
    console.log(this.permissoesUser);
    console.log(this.permissionNotInUser);
  }

  getPermissionInUser(userId) {
    this.permissionService.getPermissionInUser(userId).subscribe(data => {
      console.log(data);
    }, err => {
      console.error(err);
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/configurar-permissoes/incluir-permissao-user/incluir-permissao-user.component.ts